/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PendingPayoutDto { 
    id: string;
    organizerId: string;
    organizerName: string;
    organizerEmail: string;
    amount: number;
    requestedAt: string;
    connectedAccountStatus: string;
    status: string;
    events: Array<string>;
}

